module.exports = __webpack_public_path__ + "html/project-buttons_7debca3b3598e9da37a2a35c8abea9cb.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/project/project-buttons.html
// module id = vhpm
// module chunks = 55